<saf-side-nav
  state="closed"
  appClickOutside
  (clickOutside)="closeMenu()"
  open-svg-name="arrow-right-from-line"
  close-svg-name="arrow-left-from-line"
  role="navigation">
  <saf-menu-item
    id="history"
    routerLink="/history"
    routerLinkActive="active-link"
    (mouseleave)="onMouseLeave($event)">
    <saf-icon icon-name="house" slot="start" />Home
  </saf-menu-item>
  <saf-tooltip anchor="history" trigger-on-click="false" placement="right">
    Home
  </saf-tooltip>
  <saf-menu-item
    id="doc-upload"
    routerLink="/doc-upload"
    routerLinkActive="active-link"
    (mouseleave)="onMouseLeave($event)">
    <saf-icon icon-name="file-circle-plus" slot="start" />Doc upload
  </saf-menu-item>
  <saf-tooltip anchor="doc-upload" trigger-on-click="false" placement="right">
    Document Upload
  </saf-tooltip>
  <saf-menu-item
    id="api-keys"
    routerLink="/api-keys"
    routerLinkActive="active-link"
    (mouseleave)="onMouseLeave($event)">
    <saf-icon icon-name="key" slot="start" />API Keys
  </saf-menu-item>
  <saf-tooltip anchor="api-keys" trigger-on-click="false" placement="right">
    API Keys
  </saf-tooltip>
  @if ((isAdmin$ | async) || (isOwner$ | async)) {
    <saf-menu-item
      id="user-mgt"
      routerLink="/user-mgt"
      routerLinkActive="active-link"
      (mouseleave)="onMouseLeave($event)">
      <saf-icon icon-name="users" slot="start" />User Management
    </saf-menu-item>
    <saf-tooltip anchor="user-mgt" trigger-on-click="false" placement="right">
      User Management
    </saf-tooltip>
    <saf-menu-item
      id="product-mgt"
      routerLink="/product-mgt"
      routerLinkActive="active-link"
      (mouseleave)="onMouseLeave($event)">
      <saf-icon icon-name="cog" slot="start" />Product Management
    </saf-menu-item>
    <saf-tooltip
      anchor="product-mgt"
      trigger-on-click="false"
      placement="right">
      Product Management
    </saf-tooltip>
  }
  <saf-menu-item
    id="metrics"
    routerLink="/metrics"
    routerLinkActive="active-link"
    (mouseleave)="onMouseLeave($event)">
    <saf-icon icon-name="chart-fft" slot="start" />Metrics
  </saf-menu-item>
  <saf-tooltip anchor="metrics" trigger-on-click="false" placement="right">
    Metrics
  </saf-tooltip>
  <div class="spacer"></div>
  @if (isOwner$ | async) {
    <saf-menu-item
      id="owner-mgt"
      class="bottom-item"
      (mouseleave)="onMouseLeave($event)">
      <saf-icon icon-name="user-gear" slot="start" />Owner Management
      <saf-menu slot="submenu">
        <saf-menu-item
          id="owner-mgt-sub"
          routerLink="/owner-mgt"
          routerLinkActive="active-link"
          (mouseleave)="onMouseLeave($event)">
          <saf-icon icon-name="user" slot="start" />Owner Management
        </saf-menu-item>
        <saf-tooltip
          anchor="owner-mgt-sub"
          trigger-on-click="false"
          placement="right">
          Owner Management
        </saf-tooltip>
        <saf-menu-item
          id="feature-flags-sub"
          routerLink="/feature-flags"
          routerLinkActive="active-link"
          (mouseleave)="onMouseLeave($event)">
          <saf-icon icon-name="flag" slot="start" />Feature Flags
        </saf-menu-item>
        <saf-tooltip
          anchor="feature-flags-sub"
          trigger-on-click="false"
          placement="right">
          Feature Flags
        </saf-tooltip>
      </saf-menu>
    </saf-menu-item>
  }
</saf-side-nav>
